<template>
  <div class="service pad">

    <h1 class="title is-3 flex">
      <div class="flex-1">
        {{ machine ? machine.name : '-'}}
        Service
      </div>
      <back-button />
    </h1>

    <div v-if="service">

      <div class="columns">
        <div class="column">
          <h4 class="title is-6">Started</h4>
          <h5 class="subtitle is-6">
            {{ service.timestampStarted | unixToDateTimeString }}, {{ service.userStarted }}
          </h5>
        </div>
        <div class="column" v-if="service.timestampCompleted">
          <h4 class="title is-6">Completed</h4>
          <h5 class="subtitle is-6">
            {{ service.timestampCompleted | unixToDateTimeString }}, {{ service.userCompleted }}
          </h5>
        </div>
        <div class="column">
          <h4 class="title is-6">Status</h4>
          <h5 class="subtitle is-6">
            <b-tag :type="service.status === 'active' ? 'is-success' : ''">{{ service.status }}</b-tag>
          </h5>
        </div>
      </div>

      <div class="box">
        <repairs :machine="machine" />
      </div>

      <div v-if="service.checkList" class="margin-bottom">
        <br />
        <check-list-detailed
          :check-list="service.checkList"
          :editable="service.status === 'active'"
          @changed="checkListUpdated" />
      </div>

      <div class="box">
        <h2 class="title is-4 no-margin pad-bottom">Notes</h2>
        <div class="pad has-text-grey-light" v-if="!service.notes.length">
          there are no notes
        </div>
        <div v-else class="comment margin-bottom" v-for="note in service.notes" :key="note.timestamp">
          <div class="flex">
            <div class="flex-1 strong">{{ note.user }}</div>
            <div>{{ note.timestamp | unixToDateTimeString }}</div>
          </div>
          <div class="nl">{{ note.msg }}</div>
        </div>

        <b-input type="textarea" v-model="newNote" />
        <div class="text-right pad-top">
          <button class="button is-info" @click="addNote()">Add Note</button>
        </div>
      </div>

      <br />
      <button v-if="service.status === 'active'" class="button is-success" @click="completeService()">Complete Service</button>
      <button v-else class="button" @click="reOpenService()">Re-Open Service</button>
    </div>

  </div>
</template>

<script>
import Repairs from '@/components/Repairs'
import CheckListDetailed from '@/components/CheckListDetailed'
import { CheckListsHelper } from '@/utils/checkLists.js'
export default {
  name: 'Service',
  components: {
    CheckListDetailed,
    Repairs
  },
  data () {
    return {
      serviceId: null,
      service: null,
      machine: null,
      newNote: '',
      submittingNote: false,
      serviceUnsub: null,
      machineUnsub: null
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    machineId () { return this.service ? this.service.machineId : null }
  },
  watch: {
    serviceId () {
      this.service = null
      this.unsub('machineServices')
      if (!this.serviceId) {
        return
      }
      this.subs.machineServices = this.$firestore.collection('machineServices')
        .doc(this.serviceId)
        .onSnapshot(snapshot => {
          this.service = this.$utils.snapshotToObj(snapshot)
        })
    },
    machineId () {
      this.unsub('machines')
      if (!this.machineId) {
        return
      }

      this.subs.machines = this.$firestore.collection('machines')
        .doc(this.machineId)
        .onSnapshot(snapshot => {
          this.machine = this.$utils.snapshotToObj(snapshot)
        })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.serviceId = to.params.id
    next()
  },
  created () {
    this.serviceId = this.$route.params.id
  },
  methods: {
    completeService () {
      if (this.service.checkList) {
        let errs = CheckListsHelper.validateCheckList(this.service.checkList)
        if (errs.length) {
          let msg = '<ul class="list">'
          for (let err of errs) {
            msg += `<li>${err}</li>`
          }
          msg += '</ul>'
          this.$dialog.alert({
            title: 'Check List Incomplete',
            message: msg,
            type: 'is-warning'
          })
          return
        }
      }

      let update = {
        status: 'complete',
        timestampCompleted: this.$moment().unix(),
        userCompleted: `${this.user.firstName} ${this.user.lastName}`,
        userIdCompleted: this.user.uid
      }

      this.$firestore.collection('machineServices')
        .doc(this.serviceId)
        .update(update)
        .then(resp => this.$toast.open({ message: 'Service Complete!', type: 'is-success' }))
        .catch(err => {
          this.$toast.open({ message: 'ERROR could not complete service', type: 'is-danger' })
          this.submittingNote = false
          console.log('ERROR compleing service', err)
        })

      // UPDATE MACHINE SMU AND SET NEXT SERVICE
      if (this.service.checkList && this.service.checkList.requiresSmu) {
        let smu = Number(this.service.checkList.checks[0].value)
        update = {
          smu,
          nextService: smu + this.machine.serviceInterval,
          timestampSmuUpdated: this.$moment().unix()
        }
        this.$firestore.collection('machines')
          .doc(this.machine._id)
          .update(update)
          .then(resp => {
            console.log('smu updated')
          })
          .catch(err => {
            this.$toast.open({ message: 'ERROR could not update smu', type: 'is-danger' })
            console.log('ERROR updating smu', err)
          })
      }
    },
    reOpenService () {
      let update = { status: 'active' }
      this.$firestore.collection('machineServices')
        .doc(this.serviceId)
        .update(update)
        .then(resp => this.$toast.open({ message: 'Service Re-Opened!', type: 'is-success' }))
        .catch(err => {
          this.$toast.open({ message: 'ERROR could not re-open service', type: 'is-danger' })
          this.submittingNote = false
          console.log('ERROR re-opening service', err)
        })
    },
    checkListUpdated (checkList) {
      console.log('checkListUpdated', checkList)
      this.$firestore.collection('machineServices')
        .doc(this.serviceId)
        .update({ checkList })
        .then(resp => this.$toast.open({ message: 'ckeck list saved', type: 'is-success' }))
        .catch(err => {
          this.$toast.open({ message: 'ERROR could not update checkList', type: 'is-danger' })
          this.submittingNote = false
          console.log('ERROR updating check list', err)
        })
    },
    addNote () {
      this.newNote = this.newNote.trim()
      if (!this.newNote.length) {
        return
      }
      this.submittingNote = true
      let note = this.$utils.getBlankComment()
      note.msg = this.newNote
      this.newNote = ''
      let notes = this.service.notes || []
      notes.push(note)
      this.$firestore.collection('machineServices')
        .doc(this.serviceId)
        .update({ notes })
        .then(resp => {
          this.submittingNote = false
        })
        .catch(err => {
          this.$toast.open({ message: 'ERROR could no add note', type: 'is-danger' })
          this.submittingNote = false
          console.log('ERROR adding note', err)
        })
    }
  }
}
</script>

<style>

</style>
